import {
  Checkbox,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMemo } from "react";
import { useSingleNivel } from "../../../../context/SuperAdmin/OASContexts/SingleNivelContext";
import { StyledTableCell } from "../../../../ui-components/StyledTables";
import { SingleNivelRow } from "./SingleNivelRow";

const SingleNivelTable = () => {
  const { nivelAsigns, setSelectedNivelAsign, selectedNivelAsign, searchText } =
    useSingleNivel();

  // Filtro de items por búsqueda
  const filteredNivelAsign = useMemo(() => {
    const normalizedSearch = searchText.toLowerCase().trim();
    return nivelAsigns.filter((u) =>
      u.asignatura.toLowerCase().includes(normalizedSearch)
    );
  }, [nivelAsigns, searchText]);

  // Manejar selección/deselección de un item
  const handleSelect = (id: string) => {
    setSelectedNivelAsign((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const selectAll = () => {
    setSelectedNivelAsign(
      filteredNivelAsign.map((asign) => asign.id_nivel_asignatura)
    );
  };

  return (
    <TableContainer
      sx={{
        width: "100%",
        margin: "auto",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Table sx={{ minWidth: 500, width: "100%" }} aria-label="simple table">
        <TableHead sx={{ height: 20 }}>
          <TableRow>
            <StyledTableCell sx={{ maxWidth: "100px", width: 50 }}>
              <Checkbox
                color="primary"
                checked={selectedNivelAsign.length > 0} // Check general
                onChange={(e) => {
                  if (e.target.checked) {
                    selectAll();
                  } else {
                    setSelectedNivelAsign([]);
                  }
                }}
                sx={{
                  color: "white", // Color del checkbox cuando no está seleccionado
                  "&.Mui-checked": {
                    color: "white", // Color del icono cuando está seleccionado
                  },
                  "& .MuiSvgIcon-root": {
                    border: "2px solid white", // Borde blanco alrededor del checkbox
                    borderRadius: "4px", // Bordes redondeados
                  },
                }}
              />
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              N°
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Asignatura
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Fecha de asignación
            </StyledTableCell>
            <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>
              Estado
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredNivelAsign.length > 0 ? (
            filteredNivelAsign.map((item, index) => (
              <SingleNivelRow
                nivelAsign={item}
                i={index + 1}
                key={item.id_nivel_asignatura}
                handleSelect={handleSelect}
                isSelected={selectedNivelAsign.includes(
                  item.id_nivel_asignatura
                )}
              />
            ))
          ) : (
            <TableRow>
              <StyledTableCell
                colSpan={9}
                sx={{
                  paddingTop: "12px",
                  paddingBottom: "12px",
                  textAlign: "center",
                }}
              >
                No hay campos aún
              </StyledTableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SingleNivelTable;
